import React, { useEffect, useState } from 'react'
import { 
  Card, CardBody, 
  Button,
  Label, FormGroup
} from 'reactstrap'
import _ from 'lodash'
import HOC from './action'

import { DefaultFormValue } from './assets'
import Lang from 'Lang/General'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import ImageField from 'components/ImageField/index'

function Upload(props) {

  const [formData, setFormData] = useState(DefaultFormValue)
  
   useEffect(() => {
    if ( !_.isEmpty( props.selectedPortalUsers )) {
      props.getSelectedUpload(props.selectedPortalUsers.id )
    }
  }, [props.selectedPortalUsers])
  
  useEffect(() => {
    if ( !_.isEmpty( props.selectedUpload )) {
      setFormData(props.selectedUpload)
    }
  }, [props.selectedUpload])

  return (
    <>
      <Card className={'mt-4 mb-2'}>
        <CardBody>
          <FormGroup>
            <Label>
              {Lang['LOGO'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <ImageField
              onChange={val => {
                setFormData({
                  ... formData,
                  logo: val
                })
              }}
              fileValue={formData?.logo?.url??''}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}
              { ` 1`}
            </Label>
            <ImageField
              onChange={val => setFormData({
                ... formData,
                image_1: val
              })}
              fileValue={formData?.image_1?.url??''}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}
              { ` 2`}
            </Label>
            <ImageField
              onChange={val => setFormData({
                ... formData,
                image_2: val
              })}
              fileValue={formData?.image_2?.url??''}
            />
          </FormGroup>
          <small className="d-block mb-3">
            {Lang['FEX_ALERT_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
          </small>
          <div className="d-flex">
            <Button 
              color={'primary'}
              className={'ml-auto'}
              onClick={() => {
                let temp = _.cloneDeep(formData)
                        
                temp.image_1 = props.selectedUpload && formData.image_1.url === props.selectedUpload?.image_1.url ? null : {
                  raw: formData.image_1.raw,
                  filename: formData.image_1.filename
                }

                temp.image_2 = props.selectedUpload && formData.image_2.url === props.selectedUpload?.image_2.url ? null : {
                  raw: formData.image_2.raw,
                  filename: formData.image_2.filename
                }

                temp.logo = props.selectedUpload && formData.logo.url === props.selectedUpload?.logo.url ? null : {
                  raw: formData.logo.raw,
                  filename: formData.logo.filename
                }

                props.selectedUpload === null ? props.createUpload({
                  ... temp,
                  user_id: props.selectedPortalUsers.id
                }) : props.updateUpload(temp)
              }}
            >
              {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Button>
          </div>
        </CardBody>
      </Card>
      {
        props.onLoadUpload && <LoadingOverlay/>
      }
    </>
  )
}

export default HOC(Upload)